import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { createPhoto } from "../../api/const";

const Photo_new = ({ isOpen, onClose, onCreated }) => {
  const [photos, setPhotos] = useState([]);
  const { id: projectId } = useParams();

  if (!isOpen) return null;

  /** 파일 추가 */
  const handleFiles = (files) => {
    const newPhotos = Array.from(files).map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      title: "",
      description: "",
      activity_id: "",
    }));
    setPhotos((prev) => [...prev, ...newPhotos]);
  };

  /** 메타데이터 변경 */
  const handleMetaChange = (index, field, value) => {
    setPhotos((prev) =>
      prev.map((p, i) =>
        i === index ? { ...p, [field]: value } : p
      )
    );
  };

  /** 제목 유효성 검사 */
  const isValid = photos.every((p) => p.title.trim() !== "");


  const handleFileChange = (e) => handleFiles(e.target.files);

  const handleDrop = (e) => {
    e.preventDefault();
    handleFiles(e.dataTransfer.files);
  };

  const handleDragOver = (e) => e.preventDefault();

  /** 업로드 */
  const handleSubmit = async () => {
    if (!isValid) {
      // 모든 제목 검사 표시
      setPhotos((prev) =>
        prev.map((p) => ({
          ...p,
          error: p.title.trim() === "",
        }))
      );
      return;
    }

    try {
      await createPhoto(
        photos.map((p) => ({
          ...p,
          project: projectId,
          activity_id: p.activity?.id || null,
        }))
      );

      alert("사진이 업로드되었습니다.");
      setPhotos([]);
      onCreated?.();
      onClose();
    } catch (err) {
      alert("업로드 실패");
      console.error(err);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center">
      {/* ===== 모달 박스 ===== */}
      <div className="bg-white rounded-xl border shadow-xl w-full max-w-4xl p-6 animate-fadeIn">

        {/* ===== 헤더 ===== */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-title">시공사진 등록</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-xl"
          >
            ✕
          </button>
        </div>

        {/* ===== 파일 드래그 업로드 박스 ===== */}
        <div
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          className="border-2 border-dashed border-gray-300 hover:border-blue-400 
                     rounded-xl py-10 text-center cursor-pointer transition"
        >
          <p className="text-muted-sm">여기에 사진을 드래그하거나 아래 버튼으로 선택하세요.</p>

          <label
            htmlFor="photo-upload"
            className="btn-basic mt-4 inline-block cursor-pointer"
          >
            파일 선택
          </label>

          <input
            id="photo-upload"
            type="file"
            multiple
            accept="image/*"
            onChange={handleFileChange}
            className="hidden"
          />
        </div>

        {/* ===== 파일 리스트 ===== */}
        <div className="max-h-[400px] overflow-y-auto space-y-4 pr-2 mt-6">
          {photos.map((photo, index) => (
            <div
              key={index}
              className="grid grid-cols-1 md:grid-cols-2 gap-4 border rounded-lg p-4 bg-gray-50"
            >
              {/* 미리보기 */}
              <div className="flex items-center justify-center">
                <img
                  src={photo.preview}
                  alt=""
                  className="max-h-48 object-contain rounded border"
                />
              </div>

              {/* 입력 필드 */}
              <div>
                <div className="mb-2">
                  <input
                    type="text"
                    placeholder="제목"
                    value={photo.title}
                    onChange={(e) =>
                      handleMetaChange(index, "title", e.target.value)
                    }
                    className={`input-base ${photo.title.trim() === "" ? "border-red-500" : ""}`}
                  />

                  {photo.title.trim() === "" && (
                    <p className="text-red-500 text-xs mt-1">제목을 입력하세요.</p>
                  )}
                </div>

                <textarea
                  rows={3}
                  placeholder="설명"
                  value={photo.description}
                  onChange={(e) =>
                    handleMetaChange(index, "description", e.target.value)
                  }
                  className="input-base"
                />
              </div>
            </div>
          ))}
        </div>

        {/* ===== 버튼 영역 ===== */}
        <div className="flex justify-end gap-2 mt-6">
          <button className="btn-basic" onClick={onClose}>취소</button>

          <button
            className={`btn-save ${!isValid ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={!isValid}
            onClick={handleSubmit}
          >
            업로드
          </button>
        </div>

      </div>
    </div>
  );
};

export default Photo_new;
